import {
    SearchCategory,
    SearchResultItem,
    SearchResults,
    CustomerRow,
    DeviceRow,
    FarmRow,
    TechnicianRow,
} from "@/components/layout/Navbar/ApplicationSearch/application-search.types";

export const getSortValueCustomer = (item: CustomerRow) => item.Name;
export const getSortValueDevice = (item: DeviceRow) => item.DeviceSerialNumber;
export const getSortValueFarm = (item: FarmRow) => item.FarmLicenseKey;
export const getSortValueTechnician = (item: TechnicianRow) => item.Name ?? "";

export const toSearchResultItem = (category: SearchCategory, data: SearchResults) => {
    let items: SearchResultItem[];

    if (category === "customer") {
        items = data.customers.map((customer) => ({
            sortValue: getSortValueCustomer(customer),
            type: "customer",
            data: customer,
        }));
    } else if (category === "device") {
        items = data.devices.map((device) => ({
            sortValue: getSortValueDevice(device),
            type: "device",
            data: device,
        }));
    } else if (category === "farm") {
        items = data.farms.map((farm) => ({
            sortValue: getSortValueFarm(farm),
            type: "farm",
            data: farm,
        }));
    } else if (category === "technician") {
        items = data.technicians.map((technician) => ({
            sortValue: getSortValueTechnician(technician),
            type: "technician",
            data: technician,
        }));
    } else {
        items = [
            ...data.customers.map((customer) => ({
                sortValue: getSortValueCustomer(customer),
                type: "customerExtended" as const,
                data: customer,
            })),
            ...data.technicians.map((technician) => ({
                sortValue: getSortValueTechnician(technician),
                type: "technician" as const,
                data: technician,
            })),
        ];
    }
    return items;
};
